import Cookies from "js-cookie";
import { fetchuserContextFromAPI } from "./_fetchUserContextFromAPI";
export const passwordFailTip = async () => {
  const userInfo = Cookies.get("userInfo")
    ? JSON.parse(Cookies.get("userInfo"))
    : null;

  if (
    $("#checkout-signin-content .alert-danger").length > 0 ||
    ($("#verify-password-form").length > 0 && $(".alert-danger").length > 0)
  ) {
    //dont want to count passcode attempts against password attempts
    if (
      $("#checkout-signin-content .alert-danger")[0] &&
      $("#checkout-signin-content .alert-danger")[0].innerText &&
      $("#checkout-signin-content .alert-danger")[0].innerText.indexOf(
        "passcode"
      ) == -1
    ) {
      if (typeof Storage !== "undefined") {
        if (sessionStorage.loginfail) {
          sessionStorage.loginfail = Number(sessionStorage.loginfail) + 1;
        } else {
          sessionStorage.loginfail = 1;
        }
        if (sessionStorage.loginfail > 2) {
          var div = document.createElement("div");
          div.innerHTML =
            '\n                  <div class="parent">\n                      <h4 style="font-weight:bold;">Having trouble logging in?</h4>\n                      <span style="font-size:12px;">Make sure your password meets the following requirements:</span>\n                      <ul style="font-size:12px;">\n                        <li>Between 8 and 16 characters</li>\n                        <li>At least 1 lowercase letter</li>\n                        <li>At least 1 uppercase letter</li>\n                        <li>At least 1 number</li>\n                        <li>Characters not allowed: <>{#`~$&^+="|%}\';</li>\n                      </ul>\n                  </div>\n              ';

          if ($("#checkout-signin-content .alert-danger").length > 0) {
            $(div).insertBefore("#logonForm");
          }

          if (
            $("#verify-password-form").length > 0 &&
            $(".alert-danger").length > 0
          ) {
            $(div).insertAfter("#errors");
          }
        }
      }
    }
  }

  if ($(".my-account").length > 0) {
    sessionStorage.removeItem("loginfail");
  }

  try {
    const response = await fetchuserContextFromAPI();
    if (
      userInfo &&
      userInfo.userId &&
      response.basicInfo.callerId != -1002
    ) {
      sessionStorage.removeItem("loginfail");
    }
  } catch (e) {
    console.log(e);
  }
};
